//  公共请求
import { request } from '@/utils/request'

//  区域板块列表
export function getDistrictListAPI(data) {
  return request({
    url: '/data/GetDistrictData',
    method: 'POST',
    data
  })
}
//  首页数据统计
export function getDataCountAPI(data) {
  return request({
    url: '/data/GetGlobalStatistic',
    method: 'POST',
    data
  })
}
//  ai工具集
export function getAIToolsListAPI(data) {
  return request({
    url: '/data/GetAITools',
    method: 'POST',
    data
  })
}
//  发送手机号
export function sendPhoneCodeAPI(data) {
  return request({
    url: '/Oauth/SendWFTMsg',
    method: 'POST',
    data
  })
}